// extracted by mini-css-extract-plugin
export default {"Section__header":"Section-styles__Section__header__ziflM","Section__body":"Section-styles__Section__body__jUMaG"};